var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7164_15075)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17969 39.4039C1.17969 32.9606 6.40303 27.7372 12.8464 27.7372C19.2897 27.7372 24.513 32.9606 24.513 39.4039C24.513 45.8472 19.2897 51.0706 12.8464 51.0706C6.40303 51.0706 1.17969 45.8472 1.17969 39.4039ZM12.8464 31.2372C8.33603 31.2372 4.67969 34.8936 4.67969 39.4039C4.67969 43.9142 8.33603 47.5706 12.8464 47.5706C17.3567 47.5706 21.013 43.9142 21.013 39.4039C21.013 34.8936 17.3567 31.2372 12.8464 31.2372Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.513 38.8206C31.513 32.055 36.9975 26.5706 43.763 26.5706C50.5286 26.5706 56.013 32.055 56.013 38.8206C56.013 45.5861 50.5286 51.0706 43.763 51.0706C36.9975 51.0706 31.513 45.5861 31.513 38.8206ZM43.763 30.0706C38.9305 30.0706 35.013 33.988 35.013 38.8206C35.013 43.6531 38.9305 47.5706 43.763 47.5706C48.5956 47.5706 52.513 43.6531 52.513 38.8206C52.513 33.988 48.5956 30.0706 43.763 30.0706Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0096 7.32056C21.0096 6.35406 21.7931 5.57056 22.7596 5.57056H33.2602C34.0134 5.57056 34.6821 6.05248 34.9203 6.767L45.4236 38.267C45.7293 39.1839 45.2339 40.175 44.317 40.4807C43.4001 40.7864 42.409 40.291 42.1033 39.3741L31.999 9.07056H22.7596C21.7931 9.07056 21.0096 8.28706 21.0096 7.32056Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9339 18.7952C39.5318 19.5546 39.4008 20.6549 38.6414 21.2527L14.5795 40.1956C13.8201 40.7935 12.7198 40.6625 12.122 39.9031C11.5241 39.1437 11.6551 38.0434 12.4145 37.4456L36.4764 18.5027C37.2358 17.9048 38.3361 18.0358 38.9339 18.7952Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2023 10.3455C51.109 10.6802 51.5726 11.6866 51.2378 12.5933L49.0841 18.4266C48.8303 19.114 48.1751 19.5705 47.4424 19.5705H37.5583C36.5918 19.5705 35.8083 18.787 35.8083 17.8205C35.8083 16.854 36.5918 16.0705 37.5583 16.0705H46.2231L47.9545 11.381C48.2893 10.4743 49.2956 10.0107 50.2023 10.3455Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17969 18.9565C8.17969 17.99 8.96319 17.2065 9.92969 17.2065H18.0964C19.0629 17.2065 19.8464 17.99 19.8464 18.9565C19.8464 19.923 19.0629 20.7065 18.0964 20.7065H9.92969C8.96319 20.7065 8.17969 19.923 8.17969 18.9565Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5725 17.3175C18.4946 17.0279 19.4768 17.5407 19.7664 18.4628L23.5846 30.6207C23.8742 31.5428 23.3614 32.5251 22.4393 32.8147C21.5172 33.1043 20.535 32.5915 20.2454 31.6694L16.4272 19.5115C16.1376 18.5894 16.6504 17.6071 17.5725 17.3175Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7164_15075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    transform: "translate(0.595703 0.320679)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.7fb5ed1a.svg";
export { ForwardRef as ReactComponent };